import classNames from 'classnames';
import React, { FC, MouseEventHandler, useContext } from 'react';
import { Accordion } from '../Accordion';
import { Button } from '../Button';
import { Col } from '../Col';
import { Icon } from '../Icon';
import { Row } from '../Row';
import { VisuallyHidden } from '../VisuallyHidden';
import styles from './SelectableToggleBox.module.scss';
import { SelectableToggleBoxContext } from './SelectableToggleBoxContext';

type SelectableToggleBoxHeadingProps = {
	hideButton?: boolean;
	toggleAriaLabel?: string;
	onToggleClick?: MouseEventHandler;
};

export const SelectableToggleBoxHeading: FC<SelectableToggleBoxHeadingProps> = ({
	hideButton,
	toggleAriaLabel,
	onToggleClick,
	children,
}) => {
	const { size } = useContext(SelectableToggleBoxContext);

	return (
		<Row
			className={classNames(styles.selectableToggleBoxHeading, 'gx-8 justify-content-between align-items-center flex-nowrap', {
				['gx-xl-20']: size === 'md',
			})}
		>
			<Col xs="auto" className="flex-grow-1 flex-shrink-1">
				{children}
			</Col>

			{!hideButton && (
				<Col
					xs="auto"
					className={classNames('border-start border-grey-medium d-flex align-items-center justify-content-center', {
						['py-3']: size !== 'xs',
					})}
				>
					<Accordion.Button
						as={Button}
						size="sm"
						variant="icon"
						className={classNames('mx-n2 position-relative', {
							['mx-xl-n3']: size === 'md',
						})}
						onClick={onToggleClick}
					>
						{toggleAriaLabel && <VisuallyHidden>{toggleAriaLabel}</VisuallyHidden>}
						<Icon.ChevronBigDown position="middle" />
					</Accordion.Button>
				</Col>
			)}
		</Row>
	);
};
